import { render, staticRenderFns } from "./holding.vue?vue&type=template&id=b4276e20&"
import script from "./holding.vue?vue&type=script&lang=js&"
export * from "./holding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports